import React from "react";
import Layout from "../Layout";
import HeaderHealthcare from "./HeaderHealthcare";
import ListDirectory from "./ListDirectory";
import AdvSearch from "./AdvSearch";
import DetailsDirectory from "./DetailsDirectory";
import useUserStore from "../../utils/storeApp";
import ConfirmModal from "../shared/ConfirmModal";

const DirectorySearch = () => {
  const { userRole } = useUserStore((state) => ({
    isUserLogedIn: state.isUserLogedIn,
    userRole: state.userRole,
    userToken: state.userToken,
  }));

  return (
    <Layout>
      {userRole === "SES ADMINISTRATOR" ||
      userRole === "ADMINISTRATOR" ||
      userRole === "SYSTEMADMINISTRATOR" ? (
        <HeaderHealthcare />
      ) : null}
      <ListDirectory />
      <AdvSearch />
      <DetailsDirectory />
      <ConfirmModal />
    </Layout>
  );
};

export default DirectorySearch;
